import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.KycPage.wizard', {
    documentsUploadFailed: 'Unable to upload documents',
});
